import { useEffect, useState } from "react";

/**
 * Tracks `document.visibilityState`. Used to pause TanStack Query
 * live polling when the operator switches tabs — keeps background
 * traffic low without disabling the feature entirely.
 *
 * SSR-safe: defaults to `true` (visible) when `document` is not
 * available at render time.
 */
export function usePageVisibility(): boolean {
  const [visible, setVisible] = useState<boolean>(() => {
    if (typeof document === "undefined") return true;
    return document.visibilityState !== "hidden";
  });

  useEffect(() => {
    if (typeof document === "undefined") return;
    const onChange = () => setVisible(document.visibilityState !== "hidden");
    document.addEventListener("visibilitychange", onChange);
    return () => document.removeEventListener("visibilitychange", onChange);
  }, []);

  return visible;
}
